let cache;
if (typeof __TEST__ !== 'undefined' && __TEST__) {
  // Have to use a global during test, as the file-local variable `cache`
  // gets blown away on every file change when watching test files with
  // mocha.
  if (!global.dynamicDataCache) {
    global.dynamicDataCache = new Map();
  }
  cache = global.dynamicDataCache;
} else if (typeof __CLIENT__ !== 'undefined' && __CLIENT__) {
  cache = new Map(window.dynamicData);
  if (cache.size === 0) {
    throw new Error('could not find dynamic data map');
  }
} else {
  cache = new Map();
}

/**
 * The returned functions are used to load and retrieve the data from the dynamic data cache.
 * The 'init' function is used in './loader.js' when we initialize all of the dynamic data.
 * @param {String} name key used in dynamic data cache
 * @param {Function} fn function to make the call to set the data in the dynamic data cache
 * @param {Object} options
 * @param {Number} options.refreshInterval time period used to refresh the data interval call
 */
export const makeDynamicDataLoader = (name, fn, options = {}) => {
  const getter = () => cache.get(name);
  getter.cacheName = name;
  const loadData = (...args) =>
    Promise.resolve(cache.has(name) ? cache.get(name) : fn(data => cache.set(name, data), ...args));
  return {
    init: args => {
      if (options.refreshInterval) {
        return loadData(args).then(() => setInterval(loadData, options.refreshInterval, args));
      }
      return loadData(args);
    },
    get: getter,
    load: loadData,
  };
};
